// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_CDaxa {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
}

.content__pK_q::-webkit-scrollbar {
  display: none;
}

.content__pK_q {
  font-family: "Inter", sans-serif;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  /* max-height: 80vh; */
  background-color: var(--f5-background);
  border-radius: 12px;
  z-index: 999;
  overflow:hidden;
}

.cardsContainer_wbWNf {
  display: flex;
  flex-direction: column;
  gap: 9px;
  width: 100%;
  overflow: hidden;
}

.formAutomateContainer_yiQBt {
  overflow-x: hidden;
  border: 1px solid var(--ececf1-border);
  padding: 0px 12px;
  border-radius: 8px;
  background: var(--white-background);
  overflow-y: auto;
  margin-bottom: 1px;
  height: 100%;
  /* height: 80vh;
  display: grid; */
  grid-template-rows: 1fr 40px;
  margin: 0px 6px 6px 0px;
  select {
    padding: 0;
  }
}

.formAutomateContainer_yiQBt::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.formAutomateContainer_yiQBt::-webkit-scrollbar-thumb {
  background-color: var(--e2-background);
  border-radius: 12px;
}

.formAutomateContainer_yiQBt::-webkit-scrollbar-track {
  background: var(--white-background);
}

.body_rIvHM {
  display: grid;
  grid-template-columns: 260px 2fr;
  background: var(--f5-background);
  overflow: hidden;
  border-radius: 0px 0px 12px 12px;
  height: 100%;
}

.leftContainer_jdbwq {
  background: var(--f5-background);
  padding: 0px 10px;
  overflow-y: auto;
  height:100%;
}

.leftContainer_jdbwq::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}

.leftContainer_jdbwq::-webkit-scrollbar-thumb {
  background-color: transparent;
  border-radius: 12px;
}

.leftContainer_jdbwq::-webkit-scrollbar-track {
  background: transparent;
}


.header_enXjr {
  display: flex;
  justify-content: space-between;
  padding: 24px;
}

@media screen and (max-width: 900px) {
  .body_rIvHM {
    grid-template-columns: 70px 2fr;
  }

  .leftContainer_jdbwq {

    [class^="data_contain"] {
      [class^="icon"]{
        width: 55px;
        height: 55px;
        img {
          width: 50px;
          height: 50px;
        }
      }
      [class^="title"]{
        display: none;
        opacity: 0;
        visibility: hidden;
      }
    }

    [class^="dropdownContainer"] {
      display: none;
    }

    [class^="searchContainer"] {
      display: none !important;
    }

    p {
      display: none;
    }
  }
}




.buttonsContainer_SiI5B {
  display: flex;
  gap: 22px;
  background-color: var(--f5-background);
  justify-content: flex-end;
  align-items: center;
}


.headerLeft_QoucU {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: var(--_2-color);
  font-size: 20px;
  font-weight: 600;
  gap: 18px;

  h2 {
    font-size: 22px;
    font-weight: 600;
    color: var(--black-color);
  }
}

.closeIcon_Z1UYr {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 31px;
  height: 31px;
  cursor: pointer;
  border-radius: 4px;
  background: var(--f6-background);
  -webkit-user-select: none;
          user-select: none;
}

.backButton_Yg2wu {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  width: 23px;
  height: 23px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background: var(--_10a37f var(--_10a37f-border)-background);
}


.footer_akn7v {
  width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  /* max-width: 500px; */
  gap: 6px;
  background-color: var(--f5-background);
  box-sizing: border-box;
  padding: 10px 0px;
  margin-top: 10px;
  bottom: 15px;
  border-radius: 10px;
  font-size: 13px;
  text-align: center;
  @media (width<=528px) {
    & {
      padding: 30px 10px 22px 10px;
    }
  }

  svg {
    width: 12px;
    height: 12px;
    margin-top: -1px;
  }
}

.loaderTestConnection_BzTYG {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  position: relative;
  animation: rotate_RyboZ 1s linear infinite
}
.loaderTestConnection_BzTYG::before {
  content: "";
  box-sizing: border-box;
  position: absolute;
  inset: 0px;
  border-radius: 50%;
  border: 2px solid var(--_10a37f-border);
  animation: prixClipFix_pQrAd 2s linear infinite;
}

@keyframes rotate_RyboZ {
  100%   {transform: rotate(360deg)}
}

@keyframes prixClipFix_pQrAd {
    0%   {clip-path:polygon(50% 50%,0 0,0 0,0 0,0 0,0 0)}
    25%  {clip-path:polygon(50% 50%,0 0,100% 0,100% 0,100% 0,100% 0)}
    50%  {clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,100% 100%,100% 100%)}
    75%  {clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,0 100%,0 100%)}
    100% {clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,0 100%,0 0)}
}

.moreInfoContainer_eIeCL{
  background-color: var(--f5-background);
  transition: background-color 0.3s ease;
  border-radius: 999px;
  cursor: pointer;

  &:hover {
  stroke: #8f8f8f;

  }
}

`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/Automate/panelAutomate/panelAutomate.module.css"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,sCAAsC;EACtC,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;EACtC,iBAAiB;EACjB,kBAAkB;EAClB,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ;kBACgB;EAChB,4BAA4B;EAC5B,uBAAuB;EACvB;IACE,UAAU;EACZ;AACF;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,gCAAgC;EAChC,gBAAgB;EAChB,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;;AAGA;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE;IACE,+BAA+B;EACjC;;EAEA;;IAEE;MACE;QACE,WAAW;QACX,YAAY;QACZ;UACE,WAAW;UACX,YAAY;QACd;MACF;MACA;QACE,aAAa;QACb,UAAU;QACV,kBAAkB;MACpB;IACF;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,wBAAwB;IAC1B;;IAEA;MACE,aAAa;IACf;EACF;AACF;;;;;AAKA;EACE,aAAa;EACb,SAAS;EACT,sCAAsC;EACtC,yBAAyB;EACzB,mBAAmB;AACrB;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,SAAS;;EAET;IACE,eAAe;IACf,gBAAgB;IAChB,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gCAAgC;EAChC,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,2DAA2D;AAC7D;;;AAGA;EACE,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,QAAQ;EACR,sCAAsC;EACtC,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB;IACE;MACE,4BAA4B;IAC9B;EACF;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;EAClB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB;AACF;AACA;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,uCAAuC;EACvC,+CAA0C;AAC5C;;AAEA;EACE,QAAQ,yBAAyB;AACnC;;AAEA;IACI,MAAM,8CAA8C;IACpD,MAAM,0DAA0D;IAChE,MAAM,mEAAmE;IACzE,MAAM,6DAA6D;IACnE,MAAM,0DAA0D;AACpE;;AAEA;EACE,sCAAsC;EACtC,sCAAsC;EACtC,oBAAoB;EACpB,eAAe;;EAEf;EACA,eAAe;;EAEf;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap\");\n\n.container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100vw;\n  height: 100vh;\n}\n\n.content::-webkit-scrollbar {\n  display: none;\n}\n\n.content {\n  font-family: \"Inter\", sans-serif;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  /* max-height: 80vh; */\n  background-color: var(--f5-background);\n  border-radius: 12px;\n  z-index: 999;\n  overflow:hidden;\n}\n\n.cardsContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 9px;\n  width: 100%;\n  overflow: hidden;\n}\n\n.formAutomateContainer {\n  overflow-x: hidden;\n  border: 1px solid var(--ececf1-border);\n  padding: 0px 12px;\n  border-radius: 8px;\n  background: var(--white-background);\n  overflow-y: auto;\n  margin-bottom: 1px;\n  height: 100%;\n  /* height: 80vh;\n  display: grid; */\n  grid-template-rows: 1fr 40px;\n  margin: 0px 6px 6px 0px;\n  select {\n    padding: 0;\n  }\n}\n\n.formAutomateContainer::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n.formAutomateContainer::-webkit-scrollbar-thumb {\n  background-color: var(--e2-background);\n  border-radius: 12px;\n}\n\n.formAutomateContainer::-webkit-scrollbar-track {\n  background: var(--white-background);\n}\n\n.body {\n  display: grid;\n  grid-template-columns: 260px 2fr;\n  background: var(--f5-background);\n  overflow: hidden;\n  border-radius: 0px 0px 12px 12px;\n  height: 100%;\n}\n\n.leftContainer {\n  background: var(--f5-background);\n  padding: 0px 10px;\n  overflow-y: auto;\n  height:100%;\n}\n\n.leftContainer::-webkit-scrollbar {\n  width: 0px;\n  height: 0px;\n}\n\n.leftContainer::-webkit-scrollbar-thumb {\n  background-color: transparent;\n  border-radius: 12px;\n}\n\n.leftContainer::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  padding: 24px;\n}\n\n@media screen and (max-width: 900px) {\n  .body {\n    grid-template-columns: 70px 2fr;\n  }\n\n  .leftContainer {\n\n    [class^=\"data_contain\"] {\n      [class^=\"icon\"]{\n        width: 55px;\n        height: 55px;\n        img {\n          width: 50px;\n          height: 50px;\n        }\n      }\n      [class^=\"title\"]{\n        display: none;\n        opacity: 0;\n        visibility: hidden;\n      }\n    }\n\n    [class^=\"dropdownContainer\"] {\n      display: none;\n    }\n\n    [class^=\"searchContainer\"] {\n      display: none !important;\n    }\n\n    p {\n      display: none;\n    }\n  }\n}\n\n\n\n\n.buttonsContainer {\n  display: flex;\n  gap: 22px;\n  background-color: var(--f5-background);\n  justify-content: flex-end;\n  align-items: center;\n}\n\n\n.headerLeft {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  color: var(--_2-color);\n  font-size: 20px;\n  font-weight: 600;\n  gap: 18px;\n\n  h2 {\n    font-size: 22px;\n    font-weight: 600;\n    color: var(--black-color);\n  }\n}\n\n.closeIcon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 31px;\n  height: 31px;\n  cursor: pointer;\n  border-radius: 4px;\n  background: var(--f6-background);\n  user-select: none;\n}\n\n.backButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  width: 23px;\n  height: 23px;\n  cursor: pointer;\n  user-select: none;\n  background: var(--_10a37f var(--_10a37f-border)-background);\n}\n\n\n.footer {\n  width: 100%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  /* max-width: 500px; */\n  gap: 6px;\n  background-color: var(--f5-background);\n  box-sizing: border-box;\n  padding: 10px 0px;\n  margin-top: 10px;\n  bottom: 15px;\n  border-radius: 10px;\n  font-size: 13px;\n  text-align: center;\n  @media (width<=528px) {\n    & {\n      padding: 30px 10px 22px 10px;\n    }\n  }\n\n  svg {\n    width: 12px;\n    height: 12px;\n    margin-top: -1px;\n  }\n}\n\n.loaderTestConnection {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  position: relative;\n  animation: rotate 1s linear infinite\n}\n.loaderTestConnection::before {\n  content: \"\";\n  box-sizing: border-box;\n  position: absolute;\n  inset: 0px;\n  border-radius: 50%;\n  border: 2px solid var(--_10a37f-border);\n  animation: prixClipFix 2s linear infinite ;\n}\n\n@keyframes rotate {\n  100%   {transform: rotate(360deg)}\n}\n\n@keyframes prixClipFix {\n    0%   {clip-path:polygon(50% 50%,0 0,0 0,0 0,0 0,0 0)}\n    25%  {clip-path:polygon(50% 50%,0 0,100% 0,100% 0,100% 0,100% 0)}\n    50%  {clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,100% 100%,100% 100%)}\n    75%  {clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,0 100%,0 100%)}\n    100% {clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,0 100%,0 0)}\n}\n\n.moreInfoContainer{\n  background-color: var(--f5-background);\n  transition: background-color 0.3s ease;\n  border-radius: 999px;\n  cursor: pointer;\n\n  &:hover {\n  stroke: #8f8f8f;\n\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container_CDaxa`,
	"content": `content__pK_q`,
	"cardsContainer": `cardsContainer_wbWNf`,
	"formAutomateContainer": `formAutomateContainer_yiQBt`,
	"body": `body_rIvHM`,
	"leftContainer": `leftContainer_jdbwq`,
	"header": `header_enXjr`,
	"buttonsContainer": `buttonsContainer_SiI5B`,
	"headerLeft": `headerLeft_QoucU`,
	"closeIcon": `closeIcon_Z1UYr`,
	"backButton": `backButton_Yg2wu`,
	"footer": `footer_akn7v`,
	"loaderTestConnection": `loaderTestConnection_BzTYG`,
	"rotate": `rotate_RyboZ`,
	"prixClipFix": `prixClipFix_pQrAd`,
	"moreInfoContainer": `moreInfoContainer_eIeCL`
};
export default ___CSS_LOADER_EXPORT___;
